import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Collapse } from "reactstrap"
import { Link } from "react-router-dom"
import "../../assets/css/Layout/Header.css"
import Configs from "../../config"
import { FaCartShopping, FaLocationDot, FaUserXmark } from "react-icons/fa6"
import { HiDocumentReport } from "react-icons/hi"
import {
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaHome,
  FaUsers,
  FaPoundSign,
  FaUser,
  FaFileContract,
  FaVideo,
} from "react-icons/fa"
import {
  MdCleaningServices,
  MdSettings,
  MdQuestionAnswer,
  MdHistory,
  MdHelp,
  MdInventory2,
  MdRealEstateAgent,
  MdFeedback,
} from "react-icons/md"
import { BsClipboard2DataFill } from "react-icons/bs"
import { MdOutlineSecurity } from "react-icons/md"
import { usePermissionData } from "AppContext"
import { GrCatalog } from "react-icons/gr"
import { RiBillFill } from "react-icons/ri"

const Navbar = props => {
  const { checkAccess } = usePermissionData()

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    removeActivation(items)
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement
      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active")
        }
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  return (
    <React.Fragment>
      <div className="topnav ps-1 pe-0" style={{ zIndex: "1001" }}>
        <div className="container-fluid px-0">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav d-flex justify-content-between w-100">
                <div className="d-flex">
                  {/* dashboard */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}dashboard`}
                    >
                      <FaHome size={18} className="me-1 mb-1" />
                      {"Dashboard"} {props.menuOpen}
                    </Link>
                  </li>
                  {/* <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}services`}
                    >
                      <MdCleaningServices size={18} className="me-2 mb-1" />
                      {"Services"} {props.menuOpen}
                    </Link>
                  </li> */}
                  {(checkAccess(1, 2) || checkAccess(1, 1)) && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}calender`}
                      >
                        <FaCalendarAlt size={18} className="me-1 mb-1" />
                        {"Calendar"} {props.menuOpen}
                      </Link>
                    </li>
                  )}

                  {(checkAccess(2, 2) || checkAccess(2, 1)) && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}attendance-report`}
                      >
                        <BsClipboard2DataFill size={18} className="me-1 mb-1" />
                        Timesheet
                      </Link>
                    </li>
                  )}
                  {(checkAccess(3, 2) || checkAccess(3, 1)) && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}staff`}
                      >
                        <FaUsers size={18} className="me-1 mb-1" />
                        {"Employees"} {props.menuOpen}
                      </Link>
                    </li>
                  )}
                  {(checkAccess(4, 2) || checkAccess(4, 1)) && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}leave-management`}
                      >
                        <FaUserXmark size={18} className="me-1 mb-1" />
                        {"Holiday"} {props.menuOpen}
                      </Link>
                    </li>
                  )}
                  {(checkAccess(5, 2) || checkAccess(5, 1)) && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}locations`}
                      >
                        <FaMapMarkerAlt size={18} className="me-1 mb-1" />
                        Locations
                      </Link>
                    </li>
                  )}

                  {(checkAccess(6, 2) || checkAccess(6, 1)) && (
                    <li className="nav-item dropdown">
                      <button className="btn nav-link dropdown-toggle arrow-none">
                        <FaPoundSign size={18} className="me-1 mb-1" />
                        {"Payroll"} {props.menuOpen}
                      </button>
                      <div className="dropdown-menu" id="sales-dropdown">
                        <Link
                          className="text-dark dropdown-item"
                          to={`${Configs.appurl}payroll-report`}
                        >
                          <FaPoundSign size={18} className="me-1 mb-1" />{" "}
                          Generate
                        </Link>
                        <Link
                          to={`${Configs.appurl}payroll-history`}
                          className="text-dark dropdown-item"
                        >
                          <MdHistory size={18} className="me-1 mb-1" /> History
                        </Link>
                      </div>
                    </li>
                  )}

                  {(checkAccess(8, 2) || checkAccess(8, 1)) && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}daily-report`}
                      >
                        <HiDocumentReport size={20} className="me-1 mb-1" />
                        Reports
                      </Link>
                    </li>
                  )}

                  {(checkAccess(8, 2) || checkAccess(8, 1)) && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}expense`}
                      >
                        <RiBillFill size={20} className="me-1 mb-1" />
                        Expense
                      </Link>
                    </li>
                  )}

                  <li className="nav-item dropdown">
                    <button className="btn nav-link dropdown-toggle arrow-none">
                      <MdInventory2 size={18} className="me-1 mb-1" />
                      {"Inventory"} {props.menuOpen}
                    </button>
                    <div className="dropdown-menu" id="sales-dropdown">
                      <Link
                        className="text-dark dropdown-item"
                        to={`${Configs.appurl}orders`}
                      >
                        <FaCartShopping size={18} className="me-2 mb-1" />{" "}
                        Orders
                      </Link>
                      <Link
                        className="text-dark dropdown-item"
                        to={`${Configs.appurl}product-catalog`}
                      >
                        <GrCatalog size={18} className="me-2 mb-1" /> Products
                      </Link>
                      <Link
                        className="text-dark dropdown-item"
                        to={`${Configs.appurl}supplier  `}
                      >
                        <MdRealEstateAgent size={18} className="me-2 mb-1" />{" "}
                        Supplier
                      </Link>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}client-feedback`}
                    >
                      <MdFeedback size={18} className="me-1 mb-1" /> Feedback
                    </Link>
                  </li>

                  {(checkAccess(7, 2) || checkAccess(7, 1)) && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}user-query`}
                        title="User Query"
                      >
                        <MdQuestionAnswer size={18} className="me-1 mb-1" />
                      </Link>
                    </li>
                  )}

                  {(checkAccess(11, 2) ||
                    checkAccess(11, 1) ||
                    checkAccess(9, 2) ||
                    checkAccess(9, 1) ||
                    checkAccess(10, 2) ||
                    checkAccess(11, 1)) && (
                    <li className="nav-item dropdown">
                      <button className="btn nav-link dropdown-toggle arrow-none" title="Settings">
                        <MdSettings size={18} className="me-1 mb-1" />
                        {props.menuOpen}
                      </button>
                      <div className="dropdown-menu">
                        {(checkAccess(9, 2) || checkAccess(9, 1)) && (
                          <Link
                            to={`${Configs.appurl}services`}
                            className="text-dark dropdown-item"
                          >
                            <MdCleaningServices
                              size={18}
                              className="me-2 mb-1"
                            />{" "}
                            Services
                          </Link>
                        )}

                        {(checkAccess(10, 2) || checkAccess(11, 1)) && (
                          <Link
                            to={`${Configs.appurl}roles`}
                            className="text-dark dropdown-item"
                          >
                            <MdOutlineSecurity
                              size={18}
                              className="me-2 mb-1"
                            />{" "}
                            Roles
                          </Link>
                        )}

                        {(checkAccess(11, 2) || checkAccess(11, 1)) && (
                          <Link
                            to={`${Configs.appurl}help-section`}
                            className="text-dark dropdown-item"
                          >
                            <MdHelp size={18} className="me-2 mb-1" /> Help
                            Section
                          </Link>
                        )}
                        <Link
                          to={`${Configs.appurl}hr-section`}
                          className="text-dark dropdown-item"
                        >
                          <FaUser size={18} className="me-2 mb-1" /> HR &
                          Compliance
                        </Link>

                        <Link
                          to={`${Configs.appurl}contact-templates`}
                          className="text-dark dropdown-item"
                        >
                          <FaFileContract size={18} className="me-2 mb-1" />{" "}
                          Contract Templates
                        </Link>

                        <Link
                          to={`${Configs.appurl}admin-tutorials`}
                          className="text-dark dropdown-item"
                        >
                          <FaVideo size={18} className="me-2 mb-1" /> Admin
                          Tutorials
                        </Link>

                        <Link
                          to={`${Configs.appurl}other-locations`}
                          className="text-dark dropdown-item"
                        >
                          <FaLocationDot size={18} className="me-2 mb-1" />
                          Other Locations
                        </Link>
                      </div>
                    </li>
                  )}
                </div>
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

export default Navbar
